export default __webpack_public_path__ + "static/media/Roboto-Medium.7c8d04cd.ttf";